import { useState, useEffect } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { supabase } from '../supabase'
import NavbarPublico from '../components/NavbarPublico'
import FooterLegal from '../components/FooterLegal'

function Login({ onLoginExitoso, onIrARegistro, abrirLogin }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [cargando, setCargando] = useState(false)
  const [error, setError] = useState('')
  const [vistaActiva, setVistaActiva] = useState(abrirLogin ? 'login' : 'inicio')
  const [moneda, setMoneda] = useState('EUR')
  const [mostrarBannerPWA, setMostrarBannerPWA] = useState(false)
  const [esIOS, setEsIOS] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [instalada, setInstalada] = useState(false)
  const [mfaRequerido, setMfaRequerido] = useState(false)
  const [mfaCodigo, setMfaCodigo] = useState('')
  const [mfaFactorId, setMfaFactorId] = useState('')
  const [mfaError, setMfaError] = useState('')
const [planExpandido, setPlanExpandido] = useState(null)
  const [verPassword, setVerPassword] = useState(false)

  useEffect(() => {
    if (abrirLogin) setVistaActiva('login')
  }, [abrirLogin])

  useEffect(() => {
    const esIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)
    const esSafari = /safari/i.test(navigator.userAgent) && !/chrome/i.test(navigator.userAgent)
    const yaInstalada = window.matchMedia('(display-mode: standalone)').matches

    if (yaInstalada) { setInstalada(true); return }

    if (esIOS && esSafari) {
      setEsIOS(true)
      setMostrarBannerPWA(true)
      return
    }

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setMostrarBannerPWA(true)
    })
  }, [])

  async function instalarPWA() {
    if (deferredPrompt) {
      deferredPrompt.prompt()
      const { outcome } = await deferredPrompt.userChoice
      if (outcome === 'accepted') setInstalada(true)
      setDeferredPrompt(null)
      setMostrarBannerPWA(false)
    }
  }

  async function handleLogin(e) {
    e.preventDefault()
    setCargando(true)
    setError('')
    const { data, error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) {
      setError('Email o contraseña incorrectos')
      setCargando(false)
      return
    }
    const { data: mfaData } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel()
    if (mfaData?.nextLevel === 'aal2' && mfaData?.nextLevel !== mfaData?.currentLevel) {
      const { data: factorsData } = await supabase.auth.mfa.listFactors()
      const totp = factorsData?.totp?.[0]
      if (totp) {
        setMfaFactorId(totp.id)
        setMfaRequerido(true)
        setCargando(false)
        return
      }
    }
    onLoginExitoso()
  }

  async function handleMfa(e) {
    e.preventDefault()
    setCargando(true)
    setMfaError('')
    try {
      const { data: challengeData, error: challengeError } = await supabase.auth.mfa.challenge({ factorId: mfaFactorId })
      if (challengeError) { setMfaError('Error al iniciar verificación'); setCargando(false); return }
      const { error: verifyError } = await supabase.auth.mfa.verify({
        factorId: mfaFactorId,
        challengeId: challengeData.id,
        code: mfaCodigo,
      })
      if (verifyError) { setMfaError('Código incorrecto. Inténtalo de nuevo.'); setCargando(false); return }
      onLoginExitoso()
    } catch {
      setMfaError('Error al verificar. Inténtalo de nuevo.')
      setCargando(false)
    }
  }

  if (mfaRequerido) {
    return (
      <div style={estilos.loginPagina}>
        <NavbarPublico onIrALogin={() => setVistaActiva('inicio')} onIrARegistro={onIrARegistro} vistaActiva='login' />
        <div style={estilos.loginContenido}>
          <div style={estilos.loginCaja}>
            <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <img src="/logo-circulo.png" alt="Etern-me" style={estilos.logoLoginGrande} />
            </a>
            <p style={estilos.loginSubtitulo}>Verificación en dos pasos</p>
            <p style={{ fontSize: '13px', color: '#8B6F47', textAlign: 'center', marginBottom: '20px', lineHeight: '1.6' }}>
              Abre tu app de autenticación (Google Authenticator o Authy) e introduce el código de 6 dígitos.
            </p>
            {mfaError && <div style={estilos.errorDiv}>{mfaError}</div>}
            <form onSubmit={handleMfa} style={{ width: '100%' }}>
              <div style={estilos.campo}>
                <label style={estilos.label}>Código de verificación</label>
                <input
                  type="text"
                  value={mfaCodigo}
                  onChange={e => setMfaCodigo(e.target.value.replace(/\D/g, '').slice(0, 6))}
                  style={{ ...estilos.input, textAlign: 'center', fontSize: '24px', letterSpacing: '8px', fontWeight: '700' }}
                  placeholder="000000"
                  maxLength={6}
                  autoComplete="one-time-code"
                  required
                />
              </div>
              <button type="submit" disabled={cargando || mfaCodigo.length !== 6} style={{ ...estilos.btnPrimarioFull, opacity: (cargando || mfaCodigo.length !== 6) ? 0.7 : 1 }}>
                {cargando ? 'Verificando...' : 'Verificar'}
              </button>
            </form>
            <p style={estilos.enlace}>
              <span onClick={() => { setMfaRequerido(false); setMfaCodigo('') }} style={estilos.link}>← Volver</span>
            </p>
          </div>
        </div>
        <FooterLegal />
      </div>
    )
  }

  if (vistaActiva === 'inicio') {
    return (
      <div style={estilos.landing}>
        <NavbarPublico onIrALogin={() => setVistaActiva('login')} onIrARegistro={onIrARegistro} vistaActiva='inicio' />

        <div style={estilos.hero} className="hero">
          <div style={estilos.heroIzquierda} className="hero-izquierda">
            <div style={estilos.tagBadge}>Todo en orden. Siempre.</div>
            <h1 style={estilos.heroTitulo} className="hero-titulo">
              Organiza tu vida digital.
              <span style={estilos.heroTituloAcento}> Protege lo que más importa.</span>
            </h1>
            <p style={estilos.heroSubtitulo}>
              Tus cuentas, documentos, instrucciones y personas de confianza en un solo lugar seguro.
              Para proteger a los tuyos — y vivir con tranquilidad.
            </p>
            <p style={{ fontSize: '18px', color: '#8B2E0F', fontWeight: '600', marginBottom: '24px', lineHeight: '1.5', backgroundColor: '#FDF0EC', padding: '14px 18px', borderRadius: '10px', border: '1px solid #F5C9B8' }}>
              Si mañana te pasa algo, ¿alguien sabría qué hacer con tus cuentas, documentos y contraseñas?
            </p>
            <p style={estilos.heroUrgencia}>
  ✓ Listo en 10 minutos · ✓ Sin tarjeta · ✓ 14 días gratis
</p>
<p style={{ fontSize: '13px', color: '#8B6F47', marginBottom: '24px', fontWeight: '500' }}>
  Desde <strong style={{ color: '#2C1810' }}>4,99€/mes</strong> · $4.99 USD · $89 MXN
</p>
            <div style={estilos.heroBotones} className="hero-botones">
              <button onClick={() => onIrARegistro()} style={estilos.btnPrimario}>
                Crear mi espacio gratis
              </button>
              <button onClick={() => setVistaActiva('login')} style={estilos.btnSecundario}>
                Ya tengo cuenta
              </button>
            </div>
            <div style={estilos.featuresRow} className="features-row">
              <div style={estilos.feature}><span style={estilos.featureTexto}>Privado y bajo tu control</span></div>
              <div style={estilos.feature}><span style={estilos.featureTexto}>Mensajes programados</span></div>
              <div style={estilos.feature}><span style={estilos.featureTexto}>Siempre disponible</span></div>
            </div>
          </div>
          <div style={estilos.heroDerecha} className="hero-derecha">
            <div style={{
              position: 'relative', display: 'flex',
              justifyContent: 'center', alignItems: 'center'
            }}>
              <div style={{
                backgroundColor: '#2C1810', borderRadius: '40px',
                padding: '12px', boxShadow: '0 20px 60px rgba(44,24,16,0.25)',
                border: '3px solid #3D2418'
              }}>
                <img
                  src="/score.jpg"
                  alt="ETERN-ME app"
                  style={{
                    width: '220px', borderRadius: '28px',
                    display: 'block'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={estilos.claridad}>
          <div style={estilos.claridad_inner}>
            <h2 style={estilos.claridad_titulo}>¿Qué puedes guardar en ETERN-ME?</h2>
            <div style={estilos.claridad_grid}>
              <div style={estilos.claridad_item}><span style={estilos.claridad_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="7.5" cy="15.5" r="5.5"/><path d="M21 2l-9.6 9.6"/><path d="M15.5 7.5l3 3L22 7l-3-3"/></svg></span><span style={estilos.claridad_texto}>Cuentas y suscripciones digitales</span></div>
              <div style={estilos.claridad_item}><span style={estilos.claridad_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg></span><span style={estilos.claridad_texto}>Documentos e información importante</span></div>
              <div style={estilos.claridad_item}><span style={estilos.claridad_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></span><span style={estilos.claridad_texto}>Tu perfil personal y tus deseos</span></div>
              <div style={estilos.claridad_item}><span style={estilos.claridad_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></span><span style={estilos.claridad_texto}>Tu guardián y tu círculo de confianza</span></div>
              <div style={estilos.claridad_item}><span style={estilos.claridad_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></span><span style={estilos.claridad_texto}>Mensajes para quienes quieres</span></div>
              <div style={estilos.claridad_item}><span style={estilos.claridad_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span><span style={estilos.claridad_texto}>Instrucciones para tus mascotas</span></div>
            </div>
            <p style={estilos.claridad_sub}>Todo con control total. Tú decides quién ve qué, cuándo y cómo.</p>
          </div>
        </div>

        <div style={estilos.problema}>
          <div style={estilos.problema_inner}>
            <h2 style={estilos.seccionTitulo}>Cuando el caos llega, la angustia se multiplica</h2>
            <div style={estilos.problema_grid}>
              <div style={estilos.problema_item}><span style={estilos.problema_q}>¿Dónde están los documentos?</span></div>
              <div style={estilos.problema_item}><span style={estilos.problema_q}>¿Qué cuentas y suscripciones existen?</span></div>
              <div style={estilos.problema_item}><span style={estilos.problema_q}>¿Quién cuida a las mascotas?</span></div>
              <div style={estilos.problema_item}><span style={estilos.problema_q}>¿Qué hay que hacer primero?</span></div>
            </div>
            <p style={estilos.problema_conclusion}>Nadie debería tener que adivinar. ETERN-ME pone todo en orden — antes de que haga falta.</p>
            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <button onClick={() => onIrARegistro()} style={{
                backgroundColor: '#2C1810', color: '#FAF8F5',
                border: 'none', padding: '14px 32px', borderRadius: '10px',
                fontSize: '15px', fontWeight: '600', cursor: 'pointer'
              }}>
                Crear mi espacio gratis
              </button>
              <p style={{ fontSize: '12px', color: '#8B6F47', marginTop: '8px' }}>
                14 días gratis · Sin tarjeta
              </p>
            </div>
          </div>
        </div>

        <div style={estilos.beneficio}>
          <div style={estilos.beneficio_inner}>
            <h2 style={estilos.beneficio_titulo}>No es complicado.<br />Son 10 minutos.</h2>
<p style={estilos.beneficio_texto}>
  Hay una sensación que muy poca gente tiene resuelta: saber que, 
  pase lo que pase, las personas que quieres encontrarán todo en orden.
  Sin tener que buscar. Sin tener que adivinar. Sin perder tiempo.
</p>
<p style={estilos.beneficio_texto}>
  No hace falta que pase nada grave. Basta con organizarse hoy — 
  en 10 minutos — para vivir con esa tranquilidad todos los días.
</p>
<p style={{ ...estilos.beneficio_texto, fontWeight: '700', color: '#FAF8F5' }}>
  Eso es ETERN-ME. Todo en orden. Siempre.
</p>

          </div>
        </div>

        <div style={{ backgroundColor: '#FAF8F5', padding: '64px 32px' }}>
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <h2 style={{
              fontSize: '28px', fontWeight: '800', color: '#2C1810',
              marginBottom: '32px', textAlign: 'center', letterSpacing: '-0.5px'
            }}>
              Cuando alguien necesita actuar y no sabe por dónde empezar
            </h2>
            <div style={{
              backgroundColor: '#FFFFFF', borderRadius: '16px',
              padding: '32px', border: '1px solid #E8E0D5',
              borderLeft: '4px solid #2C1810', marginBottom: '24px'
            }}>
              <p style={{
                fontSize: '17px', color: '#2C1810', lineHeight: '1.85',
                fontStyle: 'italic', marginBottom: '16px'
              }}>
                "Tuve un imprevisto y estuve fuera de casa varios días. Mi pareja no sabía
                dónde estaban mis documentos, ni qué suscripciones teníamos activas,
                ni a quién llamar. Tardamos una semana en resolverlo todo.
                Con ETERN-ME eso no volvería a pasar."
              </p>
              <p style={{ fontSize: '13px', color: '#8B6F47', fontWeight: '600' }}>
                — Caso inspirado en historias reales de organización
              </p>
            </div>
            <div style={{
              backgroundColor: '#F0F4E8', borderRadius: '16px',
              padding: '24px', border: '1px solid #C8D5A0', textAlign: 'center'
            }}>
              <p style={{
                fontSize: '17px', color: '#3D4D1F', fontWeight: '600',
                lineHeight: '1.6', margin: 0
              }}>
                ETERN-ME existe para que cualquier imprevisto no se convierta en caos.
                Organízate hoy — en 10 minutos.
              </p>
            </div>
          </div>
        </div>

        <div style={{
          backgroundColor: '#2C1810', padding: '64px 32px', textAlign: 'center'
        }}>
          <div style={{ maxWidth: '700px', margin: '0 auto' }}>
            <div style={{
              display: 'inline-block', backgroundColor: '#8B2E0F',
              color: '#FAF8F5', fontSize: '12px', fontWeight: '700',
              padding: '6px 16px', borderRadius: '20px', marginBottom: '24px',
              letterSpacing: '0.08em', textTransform: 'uppercase'
            }}>
              Lo más importante
            </div>
            <h2 style={{
              fontSize: '36px', fontWeight: '800', color: '#FAF8F5',
              marginBottom: '20px', lineHeight: '1.2', letterSpacing: '-0.5px'
            }}>
              El sistema de alerta que actúa cuando tú no puedes.
            </h2>
            <p style={{
              fontSize: '17px', color: '#C4A882', lineHeight: '1.85',
              marginBottom: '32px'
            }}>
              Si dejas de responder durante el tiempo que tú elijas,
              tu guardián recibe un aviso automático con tus datos críticos.
              Sin llamadas de pánico. Sin adivinar qué hacer.
              Sin perder tiempo cuando cada minuto importa.
            </p>
            <div style={{
              display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '16px', marginBottom: '32px'
            }}>
              {[
                { icono: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FAF8F5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>), texto: 'Tú configuras cada cuánto tiempo se activa' },
                { icono: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FAF8F5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>), texto: 'Tu guardián recibe un aviso inmediato' },
                { icono: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FAF8F5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>), texto: 'Con tus datos médicos críticos incluidos' },
              ].map((item, i) => (
                <div key={i} style={{
                  backgroundColor: 'rgba(196,168,130,0.1)',
                  borderRadius: '12px', padding: '20px',
                  border: '1px solid rgba(196,168,130,0.2)'
                }}>
                  <div style={{ fontSize: '28px', marginBottom: '8px' }}>{item.icono}</div>
                  <div style={{ fontSize: '14px', color: '#C4A882', lineHeight: '1.5' }}>{item.texto}</div>
                </div>
              ))}
            </div>
            <button onClick={() => onIrARegistro()} style={{
              backgroundColor: '#C4A882', color: '#2C1810',
              border: 'none', padding: '14px 32px', borderRadius: '10px',
              fontSize: '15px', fontWeight: '700', cursor: 'pointer'
            }}>
              Crear mi espacio gratis
            </button>
          </div>
        </div>

         <div style={estilos.comoFunciona}>
          <div style={{ maxWidth: '1000px', margin: '0 auto', width: '100%' }}>
            <h2 style={estilos.seccionTitulo}>Cómo funciona</h2>
            <div style={{
              display: 'flex', alignItems: 'flex-start', gap: '0',
              overflowX: 'auto', paddingBottom: '8px'
            }} className="pasos">
              {[
                {
                  num: '1',
                  titulo: 'Añade tu información',
                  texto: 'Cuentas, documentos, perfil personal — todo en un lugar seguro y privado.',
                  icono: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/><line x1="12" y1="11" x2="16" y2="11"/><line x1="12" y1="16" x2="16" y2="16"/><line x1="8" y1="11" x2="8.01" y2="11"/><line x1="8" y1="16" x2="8.01" y2="16"/></svg>)
                },
                {
                  num: '2',
                  titulo: 'Define quién accede',
                  texto: 'Asigna tu guardián y tu círculo. Tú decides qué ve cada uno.',
                  icono: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>)
                },
                {
                  num: '3',
                  titulo: 'Activa la alerta',
                  texto: 'Si dejas de responder, tu guardián sabrá qué hacer. Sin angustia innecesaria.',
                  icono: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>),
                  clave: true
                },
                {
                  num: '4',
                  titulo: 'Todo listo, siempre',
                  texto: 'Tu información disponible cuando se necesite. Modifícala cuando quieras.',
                  icono: (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>)
                },
              ].map((paso, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', flex: 1, minWidth: '200px' }}>
                  <div style={{
                    backgroundColor: '#FFFFFF', borderRadius: '16px',
                    padding: '24px 20px', border: paso.clave ? '2px solid #2C1810' : '1px solid #E8E0D5',
                    textAlign: 'center', flex: 1,
                    boxShadow: paso.clave ? '0 4px 16px rgba(44,24,16,0.12)' : 'none'
                  }}>
                    <div style={{ fontSize: '28px', marginBottom: '12px' }}>{paso.icono}</div>
                    <div style={{
                      width: '32px', height: '32px', borderRadius: '50%',
                      backgroundColor: '#2C1810', color: '#FAF8F5',
                      fontSize: '14px', fontWeight: '700',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 12px'
                    }}>{paso.num}</div>
                    {paso.clave && (
                      <div style={{
                        backgroundColor: '#2C1810', color: '#C4A882',
                        fontSize: '9px', fontWeight: '700', padding: '2px 8px',
                        borderRadius: '10px', marginBottom: '8px',
                        display: 'inline-block', letterSpacing: '0.05em'
                      }}>CLAVE</div>
                    )}
                    <h3 style={{ fontSize: '14px', fontWeight: '600', color: '#2C1810', marginBottom: '8px' }}>
                      {paso.titulo}
                    </h3>
                    <p style={{ fontSize: '13px', color: '#8B6F47', lineHeight: '1.6', margin: 0 }}>
                      {paso.texto}
                    </p>
                  </div>
                  {i < 3 && (
                    <div className="flecha-paso" style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      padding: '0 8px', marginTop: '60px', flexShrink: 0,
                      color: '#C4A882', fontSize: '20px', fontWeight: '300'
                    }}>→</div>
                  )}
                </div>
              ))}
            </div>
            <style>{`
  @media (max-width: 768px) {
    .hero { flex-direction: column !important; padding: 32px 20px !important; gap: 24px !important; }
    .hero-izquierda { max-width: 100% !important; }
    .hero-derecha { display: none !important; }
    .hero-titulo { font-size: 28px !important; }
    .hero-botones { flex-direction: column !important; }
    .features-row { flex-wrap: wrap !important; gap: 8px !important; }
    .pasos { flex-direction: column !important; }
    .pasos > div { min-width: 100% !important; }
    .flecha-paso { display: none !important; }
  }
`}</style>
          </div>
        </div>

        <div style={estilos.trust}>
          <div style={estilos.trust_inner}>
            <h2 style={estilos.seccionTitulo}>Seguridad y control total</h2>
            <div style={estilos.trust_grid}>
              <div style={estilos.trust_item}><span style={estilos.trust_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span><div><div style={estilos.trust_titulo}>Acceso solo autorizado por ti</div><div style={estilos.trust_desc}>Nadie puede acceder a tu información sin tu permiso explícito.</div></div></div>
              <div style={estilos.trust_item}><span style={estilos.trust_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></span><div><div style={estilos.trust_titulo}>Datos cifrados</div><div style={estilos.trust_desc}>Cifrado en tránsito y en reposo. Tu información está protegida en todo momento.</div></div></div>
              <div style={estilos.trust_item}><span style={estilos.trust_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg></span><div><div style={estilos.trust_titulo}>Control por niveles</div><div style={estilos.trust_desc}>Tú decides qué ve cada persona. Diferentes niveles de acceso para diferentes personas.</div></div></div>
              <div style={estilos.trust_item}><span style={estilos.trust_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></span><div><div style={estilos.trust_titulo}>Elimina todo cuando quieras</div><div style={estilos.trust_desc}>Puedes modificar, actualizar o eliminar toda tu información en cualquier momento.</div></div></div>
              <div style={estilos.trust_item}><span style={estilos.trust_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg></span><div><div style={estilos.trust_titulo}>Diseñado con enfoque en privacidad</div><div style={estilos.trust_desc}>Desarrollado con atención a la privacidad y protección de datos conforme a la normativa europea.</div></div></div>
              <div style={estilos.trust_item}><span style={estilos.trust_icono}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg></span><div><div style={estilos.trust_titulo}>Sin publicidad, sin cesión de datos</div><div style={estilos.trust_desc}>No vendemos tus datos. Tu información es tuya y solo tú decides quién puede acceder a ella.</div></div></div>
            </div>
          </div>
        </div>

        <div style={estilos.glosario}>
          <div style={estilos.glosarioContenido}>
            <h2 style={estilos.glosarioTitulo}>¿No conoces algún término?</h2>
            <div style={estilos.glosarioGrid}>
              <div style={estilos.glosarioItem}><span style={estilos.glosarioTermino}>🔔 Sistema de alerta</span><span style={estilos.glosarioDesc}>Te enviamos una señal periódica para confirmar que estás bien. Si no respondes, tu guardián recibe un aviso. Tú configuras cuándo y cómo.</span></div>
              <div style={estilos.glosarioItem}><span style={estilos.glosarioTermino}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '8px'}}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> Mi círculo</span><span style={estilos.glosarioDesc}>Persona que podrá acceder a tu información si algo te ocurre. Tú decides quién es, qué puede ver y en qué condiciones.</span></div>
              <div style={estilos.glosarioItem}><span style={estilos.glosarioTermino}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '8px'}}><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg> Cartas</span><span style={estilos.glosarioDesc}>Palabras, fotos o videos que preparas para que lleguen a quienes quieres — en una fecha especial o cuando tú decidas. Mensajes con intención y cariño.</span></div>
              <div style={estilos.glosarioItem}><span style={estilos.glosarioTermino}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '8px'}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> Mi historia</span><span style={estilos.glosarioDesc}>Mensajes y recuerdos que se entregarán en la fecha que tú elijas — un cumpleaños, una graduación, un aniversario. Para estar presente en los momentos que importan.</span></div>
              <div style={estilos.glosarioItem}><span style={estilos.glosarioTermino}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2C1810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '8px'}}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> Mi guardián</span><span style={estilos.glosarioDesc}>La persona que activará el acceso a tu información cuando sea necesario. Puede ser familiar, amigo, médico o quien tú elijas.</span></div>
              <div style={estilos.glosarioItem}><span style={estilos.glosarioTermino}>🐾 Instrucciones para mascotas</span><span style={estilos.glosarioDesc}>Todo lo que quien cuide a tus mascotas necesita saber: alimentación, veterinario, rutinas. Porque ellos también son tu familia.</span></div>
            </div>
          </div>
        </div>

        <div style={estilos.introSection}>
          <div style={estilos.introContenido}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center', marginBottom: '24px', flexWrap: 'wrap' }}>
              <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                <img src="/logo-circulo.png" alt="ETERN-ME" style={{ ...estilos.introLogo, margin: 0 }} />
              </a>
              <div style={{ textAlign: 'left' }}>
                <div style={{ fontSize: '16px', fontWeight: '700', color: '#FAF8F5', marginBottom: '4px' }}>Melina Rivera</div>
                <div style={{ fontSize: '13px', color: '#C4A882' }}>Psicóloga & Tanatóloga · Fundadora de ETERN-ME</div>
              </div>
            </div>
            <p style={{ ...estilos.introTexto, fontSize: '19px', fontWeight: '500' }}>
              "Durante años acompañé a personas en momentos de incertidumbre. Siempre vi lo mismo: cuando algo se tuerce, la falta de organización lo complica todo."
            </p>
            <p style={estilos.introTexto}>
              ETERN-ME nació de esa experiencia. Organizar tu información no es pensar en lo peor — es vivir con la tranquilidad de saber que todo está en orden, pase lo que pase.
            </p>
            <p style={estilos.introFirma}>— Melina Rivera, fundadora · etern-me.com</p>
          </div>
        </div>

        <div style={estilos.precios}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h2 style={estilos.seccionTitulo}>Planes y precios</h2>
            <p style={estilos.preciosSubtitulo}>14 días de prueba gratis. Sin tarjeta de crédito.</p>
            <p style={estilos.preciosContexto}>Menos de lo que cuesta un café a la semana. Menos de lo que cuesta un café a la semana. Para tener todo en orden cuando más se necesita.</p>
            <div style={estilos.monedaToggle}>
              <button onClick={() => setMoneda('MXN')} style={{ ...estilos.monedaBtn, backgroundColor: moneda === 'MXN' ? '#2C1810' : 'transparent', color: moneda === 'MXN' ? '#FAF8F5' : '#8B6F47' }}>MXN $</button>
              <button onClick={() => setMoneda('EUR')} style={{ ...estilos.monedaBtn, backgroundColor: moneda === 'EUR' ? '#2C1810' : 'transparent', color: moneda === 'EUR' ? '#FAF8F5' : '#8B6F47' }}>EUR €</button>
              <button onClick={() => setMoneda('USD')} style={{ ...estilos.monedaBtn, backgroundColor: moneda === 'USD' ? '#2C1810' : 'transparent', color: moneda === 'USD' ? '#FAF8F5' : '#8B6F47' }}>USD $</button>
            </div>
           <div style={estilos.planesGrid} className="planes-grid">
           {/* BÁSICO */}
<div style={estilos.planCard} className="plan-card">
  <div style={estilos.planNombre}>Básico</div>
  <div style={estilos.planPrecio}>
    {moneda === 'EUR' ? '4,99€' : moneda === 'USD' ? '$4.99' : '$89'}<span style={estilos.planPeriodo}>/mes</span>
  </div>
  <div style={estilos.planAnual}>o {moneda === 'EUR' ? '39,99€' : moneda === 'USD' ? '$39.99' : '$749'}/año — ahorra 2 meses</div>
  <div style={estilos.planDescripcion}>Para empezar a tener todo en orden</div>
  <button onClick={() => onIrARegistro()} style={estilos.planBtnSecundario}>Probar 14 días gratis</button>
  <button onClick={() => setPlanExpandido(planExpandido === 'basico' ? null : 'basico')}
    style={{ backgroundColor: 'transparent', border: 'none', color: '#8B6F47', fontSize: '13px', cursor: 'pointer', padding: '4px 0', textAlign: 'center', width: '100%' }}>
    {planExpandido === 'basico' ? '▲ Ocultar detalle' : '▼ Ver qué incluye'}
  </button>
  {planExpandido === 'basico' && (
    <ul style={estilos.planFeatures}>
      <li style={estilos.planFeature}>✓ Servicios y suscripciones sin límite</li>
      <li style={estilos.planFeature}>✓ 5 servicios guardados</li>
      <li style={estilos.planFeature}>✓ 1 persona en tu círculo</li>
      <li style={estilos.planFeature}>✓ 1 guardián de confianza</li>
      <li style={estilos.planFeature}>✓ Sistema de alerta básico</li>
      <li style={estilos.planFeature}>✓ Mi perfil personal</li>
      <li style={estilos.planFeatureNo}>✗ Cartas personales</li>
      <li style={estilos.planFeatureNo}>✗ Mi historia</li>
    </ul>
  )}
</div>

{/* PRO */}
<div style={estilos.planCard} className="plan-card">
  <div style={estilos.planNombre}>Pro</div>
  <div style={estilos.planPrecio}>
    {moneda === 'EUR' ? '9,99€' : moneda === 'USD' ? '$9.99' : '$169'}<span style={estilos.planPeriodo}>/mes</span>
  </div>
  <div style={estilos.planAnual}>o {moneda === 'EUR' ? '79,99€' : moneda === 'USD' ? '$79.99' : '$1,390'}/año — ahorra 2 meses</div>
  <div style={estilos.planDescripcion}>Para mejorar tu organización y proteger a tu círculo</div>
  <button onClick={() => onIrARegistro()} style={estilos.planBtnSecundario}>Probar 14 días gratis</button>
  <button onClick={() => setPlanExpandido(planExpandido === 'pro' ? null : 'pro')}
    style={{ backgroundColor: 'transparent', border: 'none', color: '#8B6F47', fontSize: '13px', cursor: 'pointer', padding: '4px 0', textAlign: 'center', width: '100%' }}>
    {planExpandido === 'pro' ? '▲ Ocultar detalle' : '▼ Ver qué incluye'}
  </button>
  {planExpandido === 'pro' && (
    <ul style={estilos.planFeatures}>
      <li style={estilos.planFeature}>✓ Servicios y suscripciones sin límite</li>
      <li style={estilos.planFeature}>✓ 15 servicios guardados</li>
      <li style={estilos.planFeature}>✓ Hasta 3 personas en tu círculo</li>
      <li style={estilos.planFeature}>✓ Sistema de alerta personalizable</li>
      <li style={estilos.planFeature}>✓ Mi perfil + Mis deseos</li>
      <li style={estilos.planFeature}>✓ Mascotas (hasta 3)</li>
      <li style={estilos.planFeature}>✓ Hasta 10 cartas personales</li>
      <li style={estilos.planFeatureNo}>✗ Mi historia</li>
    </ul>
  )}
</div>

{/* PREMIUM */}
<div style={{ ...estilos.planCard, ...estilos.planCardDestacado }} className="plan-card-destacado">
  <div style={estilos.planBadge}>Todo organizado ⭐</div>
  <div style={{ ...estilos.planNombre, color: '#FAF8F5' }}>Premium</div>
  <div style={{ ...estilos.planPrecio, color: '#FAF8F5' }}>
    {moneda === 'EUR' ? '14,99€' : moneda === 'USD' ? '$14.99' : '$249'}<span style={{ ...estilos.planPeriodo, color: '#C4A882' }}>/mes</span>
  </div>
  <div style={{ ...estilos.planAnual, color: '#C4A882' }}>o {moneda === 'EUR' ? '119,99€' : moneda === 'USD' ? '$119.99' : '$1,990'}/año — ahorra 2 meses</div>
  <div style={{ ...estilos.planDescripcion, color: '#C4A882' }}>Para tener TODO organizado, sin excepciones</div>
  <button onClick={() => onIrARegistro()} style={estilos.planBtnPrimario}>Probar 14 días gratis</button>
  <button onClick={() => setPlanExpandido(planExpandido === 'premium' ? null : 'premium')}
    style={{ backgroundColor: 'transparent', border: 'none', color: '#C4A882', fontSize: '13px', cursor: 'pointer', padding: '4px 0', textAlign: 'center', width: '100%' }}>
    {planExpandido === 'premium' ? '▲ Ocultar detalle' : '▼ Ver qué incluye'}
  </button>
  {planExpandido === 'premium' && (
    <ul style={estilos.planFeatures}>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>✓ Todo ilimitado</li>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>✓ Círculo ilimitado</li>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>✓ Sistema de alerta completo</li>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>✓ Mi perfil + Mis deseos</li>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>✓ Mascotas ilimitadas</li>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>⭐ Cartas ilimitadas</li>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>⭐ Mi historia</li>
      <li style={{ ...estilos.planFeature, color: '#FAF8F5' }}>⭐ Checklist de documentos</li>
    </ul>
  )}

            </div>
           </div>
            <p style={estilos.preciosNota}>Todos los planes incluyen 14 días de prueba gratis · Cifrado de datos · Soporte por email · Cancela cuando quieras</p>
          </div>
        </div>

        <div style={estilos.ctaFinal}>
          <div style={estilos.ctaFinal_inner}>
            <h2 style={estilos.ctaFinal_titulo}>Empieza hoy.</h2>
            <p style={estilos.ctaFinal_sub}>Organízate hoy, en 10 minutos.</p>
            <button onClick={() => onIrARegistro()} style={estilos.ctaFinal_btn}>Crear mi espacio gratis</button>
            <p style={estilos.ctaFinal_nota}>14 días gratis · Sin tarjeta · Cancela cuando quieras</p>
          </div>
        </div>

        <div style={estilos.contacto}>
          <div style={estilos.contactoContenido}>
            <h2 style={estilos.contactoTitulo}>¿Tienes alguna pregunta?</h2>
            <p style={estilos.contactoSubtitulo}>Estoy aquí para ayudarte. Escríbeme y te respondo lo antes posible.</p>
            <form action="https://formspree.io/f/myklwbjz" method="POST" style={estilos.formularioContacto}>
              <input type="hidden" name="_next" value="https://etern-me.com" />
              <input type="text" name="nombre" placeholder="Tu nombre" required style={estilos.inputContacto} />
              <input type="email" name="email" placeholder="Tu email" required style={estilos.inputContacto} />
              <textarea name="mensaje" placeholder="Tu mensaje" required rows="4" style={estilos.textareaContacto} />
              <button type="submit" style={estilos.contactoBtn}>Enviar mensaje</button>
            </form>
          </div>
        </div>

        {mostrarBannerPWA && !instalada && (
          <div style={{ ...estilos.pwaBanner, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }} className="pwa-banner">
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flex: 1 }}>
              <span style={estilos.pwaIcono}>📲</span>
              <div style={estilos.pwaTexto}>
                <strong>Instala ETERN-ME como app</strong>
                {esIOS
                  ? <span> — En Safari: toca <strong>Compartir →</strong> "Añadir a pantalla de inicio"</span>
                  : <span> — Instálala en tu dispositivo para acceso rápido sin navegador</span>
                }
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
              {!esIOS && deferredPrompt && (
                <button onClick={instalarPWA} style={{
                  backgroundColor: '#2C1810', color: '#FAF8F5',
                  border: 'none', padding: '8px 16px', borderRadius: '8px',
                  fontSize: '13px', fontWeight: '600', cursor: 'pointer'
                }}>
                  Instalar
                </button>
              )}
              <button onClick={() => setMostrarBannerPWA(false)} style={{
                backgroundColor: 'transparent', border: 'none',
                color: '#8B6F47', fontSize: '18px', cursor: 'pointer', padding: '4px 8px'
              }}>✕</button>
            </div>
          </div>
        )}

        <footer style={estilos.footer}>
          <div style={estilos.footerContenido} className="footer-contenido">
            <div style={estilos.footerMarca}>
              <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                <img src="/logo-circulo.png" alt="Etern-me" style={estilos.logoFooter} />
              </a>
            </div>
            <p style={estilos.footerCopy}>2026 ETERN-ME · Todos los derechos reservados · Creado por Melina Rivera</p>
            <div style={estilos.footerLinks}>
              <a href="/privacidad" style={estilos.footerLink}>Privacidad</a>
              <a href="/terminos" style={estilos.footerLink}>Términos</a>
              <a href="/aviso-legal" style={estilos.footerLink}>Aviso Legal</a>
            </div>
          </div>
        </footer>

        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={estilos.btnArriba} title="Volver arriba">↑</button>
      </div>
    )
  }

  return (
    <div style={estilos.loginPagina}>
      <NavbarPublico onIrALogin={() => setVistaActiva('inicio')} onIrARegistro={onIrARegistro} vistaActiva='login' />
      <div style={estilos.loginContenido}>
        <div style={estilos.loginCaja}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/logo-circulo.png" alt="Etern-me" style={estilos.logoLoginGrande} />
          </a>
          <p style={estilos.loginSubtitulo}>Nos alegra verte de nuevo</p>
          {error && <div style={estilos.errorDiv}>{error}</div>}
          <form onSubmit={handleLogin} style={{ width: '100%' }}>
            <div style={estilos.campo}>
              <label style={estilos.label}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={estilos.input} placeholder="tu@email.com" required />
            </div>
            <div style={estilos.campo}>
              <label style={estilos.label}>Contraseña</label>
              <div style={{ position: "relative", width: "100%" }}><input type={verPassword ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} style={{...estilos.input, paddingRight: "40px"}} placeholder="Tu contraseña" required /><button type="button" onClick={() => setVerPassword(!verPassword)} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#8B6F47", fontSize: "16px" }}>{verPassword ? <EyeOff size={18} /> : <Eye size={18} />}</button></div>
            </div>
            <p style={{ textAlign: 'right', marginBottom: '12px', marginTop: '-8px' }}>
              <span
                onClick={async () => {
                  if (!email) { setError('Introduce tu email primero.'); return }
                  const { error } = await supabase.auth.resetPasswordForEmail(email, {
                    redirectTo: 'https://etern-me.com'
                  })
                  if (error) { setError('Error al enviar el email.'); return }
                  setError('')
                  alert('Te hemos enviado un email para recuperar tu contraseña. Revisa tu bandeja de entrada.')
                }}
                style={{ fontSize: '13px', color: '#8B6F47', cursor: 'pointer', textDecoration: 'underline' }}
              >
                ¿Olvidaste tu contraseña?
              </span>
            </p>
            <button type="submit" disabled={cargando} style={{ ...estilos.btnPrimarioFull, opacity: cargando ? 0.7 : 1 }}>
              {cargando ? 'Entrando...' : 'Iniciar sesión'}
            </button>
          </form>
          <p style={estilos.enlace}>¿No tienes cuenta?{' '}<span onClick={() => onIrARegistro()} style={estilos.link}>Empieza tu prueba gratis</span></p>
        </div>
      </div>
      <FooterLegal />
    </div>
  )
}

const estilos = {
  landing: { minHeight: '100vh', backgroundColor: '#FAF8F5', width: '100%', paddingTop: '64px' },
  hero: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '1100px', margin: '0 auto', padding: '20px 32px', gap: '48px' },
  heroIzquierda: { flex: 1, maxWidth: '520px' },
  tagBadge: { display: 'inline-block', backgroundColor: '#F0F4E8', color: '#5C6B3A', fontSize: '12px', fontWeight: '600', padding: '6px 14px', borderRadius: '20px', marginBottom: '12px', letterSpacing: '0.05em' },
  heroTitulo: { fontSize: '48px', fontWeight: '800', color: '#2C1810', lineHeight: '1.15', marginBottom: '12px', letterSpacing: '-1px' },
  heroTituloAcento: { color: '#8B6F47' },
  heroSubtitulo: { fontSize: '17px', color: '#5C4033', lineHeight: '1.7', marginBottom: '8px' },
  heroUrgencia: { fontSize: '14px', color: '#5C6B3A', marginBottom: '16px', fontWeight: '600' },
  heroBotones: { display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' },
  btnPrimario: { backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', padding: '14px 28px', borderRadius: '10px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' },
  btnSecundario: { backgroundColor: 'transparent', color: '#2C1810', border: '1.5px solid #C4A882', padding: '14px 28px', borderRadius: '10px', fontSize: '15px', fontWeight: '500', cursor: 'pointer' },
  featuresRow: { display: 'flex', gap: '24px', flexWrap: 'wrap' },
  feature: { display: 'flex', alignItems: 'center', gap: '6px' },
  featureTexto: { fontSize: '13px', color: '#8B6F47', fontWeight: '500' },
  heroDerecha: { flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', minHeight: '400px', maxWidth: '380px' },
  logoCirculo: { backgroundColor: '#FFFFFF', borderRadius: '50%', padding: '24px', alignItems: "center", justifyContent: "center", boxShadow: '0 4px 24px rgba(44,24,16,0.08)' },
  logoGrandeImg: { width: '280px', height: '280px', objectFit: 'contain' },
  claridad: { backgroundColor: '#F0EAE0', padding: '64px 32px' },
  claridad_inner: { maxWidth: '900px', margin: '0 auto', textAlign: 'center' },
  claridad_titulo: { fontSize: '28px', fontWeight: '700', color: '#2C1810', marginBottom: '32px', letterSpacing: '-0.5px' },
  claridad_grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginBottom: '24px' },
  claridad_item: { display: 'flex', alignItems: 'center', gap: '12px', backgroundColor: '#FFFFFF', padding: '16px 20px', borderRadius: '12px', border: '1px solid #E8E0D5', textAlign: 'left' },
  claridad_icono: { fontSize: '24px', flexShrink: 0 },
  claridad_texto: { fontSize: '14px', color: '#2C1810', fontWeight: '500', lineHeight: '1.4' },
  claridad_sub: { fontSize: '14px', color: '#8B6F47', fontStyle: 'italic' },
  problema: { backgroundColor: '#FAF8F5', padding: '64px 32px' },
  problema_inner: { maxWidth: '700px', margin: '0 auto', textAlign: 'center' },
  problema_grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', margin: '32px 0' },
  problema_item: { backgroundColor: '#FDF0EC', borderRadius: '12px', padding: '20px', border: '1px solid #F5C9B8' },
  problema_q: { fontSize: '15px', color: '#8B2E0F', fontWeight: '500', lineHeight: '1.5' },
  problema_conclusion: { fontSize: '16px', color: '#2C1810', fontWeight: '600', lineHeight: '1.7', marginTop: '8px' },
  beneficio: { backgroundColor: '#2C1810', padding: '80px 32px' },
  beneficio_inner: { maxWidth: '680px', margin: '0 auto', textAlign: 'center' },
  beneficio_titulo: { fontSize: '32px', fontWeight: '800', color: '#FAF8F5', marginBottom: '24px', lineHeight: '1.3', letterSpacing: '-0.5px' },
  beneficio_texto: { fontSize: '17px', color: '#C4A882', lineHeight: '1.85', marginBottom: '20px' },
  comoFunciona: { backgroundColor: '#F0EAE0', padding: '80px 32px', width: '100%' },
  seccionTitulo: { fontSize: '32px', fontWeight: '700', color: '#2C1810', textAlign: 'center', marginBottom: '48px', letterSpacing: '-0.5px' },
  pasos: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', maxWidth: '800px', margin: '0 auto', width: '100%' },
  paso: { backgroundColor: '#FFFFFF', borderRadius: '16px', padding: '24px 20px', border: '1px solid #E8E0D5', textAlign: 'center', minWidth: '0' },
  pasoNum: { width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#2C1810', color: '#FAF8F5', fontSize: '18px', fontWeight: '700', alignItems: "center", justifyContent: "center", margin: '0 auto 16px' },
  pasoTitulo: { fontSize: '16px', fontWeight: '600', color: '#2C1810', marginBottom: '10px' },
  pasoTexto: { fontSize: '14px', color: '#8B6F47', lineHeight: '1.6' },
  trust: { backgroundColor: '#FAF8F5', padding: '80px 32px' },
  trust_inner: { maxWidth: '900px', margin: '0 auto' },
  trust_grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px' },
  trust_item: { display: 'flex', gap: '16px', alignItems: 'flex-start', backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '12px', border: '1px solid #E8E0D5' },
  trust_icono: { fontSize: '24px', flexShrink: 0 },
  trust_titulo: { fontSize: '14px', fontWeight: '600', color: '#2C1810', marginBottom: '4px' },
  trust_desc: { fontSize: '13px', color: '#8B6F47', lineHeight: '1.5' },
  introSection: { backgroundColor: '#2C1810', padding: '80px 32px' },
  introContenido: { maxWidth: '680px', margin: '0 auto', textAlign: 'center' },
  introLogo: { width: '110px', height: '110px', objectFit: 'contain', borderRadius: '50%', display: 'block', margin: '0 auto 32px' },
  introTexto: { fontSize: '17px', color: '#C4A882', lineHeight: '1.85', marginBottom: '20px', fontStyle: 'italic' },
  introFirma: { fontSize: '14px', color: '#8B6F47', marginTop: '28px', fontWeight: '500', letterSpacing: '0.03em' },
  precios: { backgroundColor: '#FAF8F5', padding: '80px 32px' },
  preciosSubtitulo: { fontSize: '16px', color: '#8B6F47', textAlign: 'center', marginBottom: '8px', marginTop: '-32px' },
  preciosContexto: { fontSize: '14px', color: '#8B6F47', textAlign: 'center', marginBottom: '32px', fontStyle: 'italic' },
  monedaToggle: { display: 'flex', justifyContent: 'center', backgroundColor: '#F0EAE0', borderRadius: '8px', padding: '4px', width: 'fit-content', margin: '0 auto 40px' },
  monedaBtn: { padding: '8px 20px', borderRadius: '6px', border: 'none', fontSize: '14px', fontWeight: '500', cursor: 'pointer' },
  planesGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', maxWidth: '900px', margin: '0 auto', alignItems: 'start' },
  planCard: { backgroundColor: '#FFFFFF', borderRadius: '16px', padding: '28px 24px', border: '1px solid #E8E0D5', display: 'flex', flexDirection: 'column', gap: '16px' },
  planCardDestacado: { backgroundColor: '#2C1810', border: '2px solid #26120a', transform: 'scale(1.03)' },
  planBadge: { backgroundColor: '#C4A882', color: '#2C1810', fontSize: '11px', fontWeight: '700', padding: '4px 12px', borderRadius: '20px', textAlign: 'center', letterSpacing: '0.05em', textTransform: 'uppercase', width: 'fit-content', margin: '0 auto' },
  planNombre: { fontSize: '18px', fontWeight: '700', color: '#2C1810', textAlign: 'center' },
  planPrecio: { fontSize: '36px', fontWeight: '800', color: '#2C1810', textAlign: 'center', letterSpacing: '-1px' },
  planPeriodo: { fontSize: '14px', fontWeight: '400', color: '#8B6F47' },
  planAnual: { fontSize: '12px', color: '#8B6F47', textAlign: 'center', marginTop: '-8px' },
  planDescripcion: { fontSize: '13px', color: '#8B6F47', textAlign: 'center', fontStyle: 'italic', marginTop: '-8px' },
  planFeatures: { listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', flex: 1 },
  planFeature: { fontSize: '13px', color: '#5C4033', lineHeight: '1.4' },
  planFeatureNo: { fontSize: '13px', color: '#C4A882', lineHeight: '1.4' },
  planBtnPrimario: { width: '100%', padding: '12px', backgroundColor: '#C4A882', color: '#2C1810', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  planBtnSecundario: { width: '100%', padding: '12px', backgroundColor: 'transparent', color: '#2C1810', border: '1.5px solid #C4A882', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' },
  preciosNota: { textAlign: 'center', fontSize: '12px', color: '#C4A882', marginTop: '24px' },
  glosario: { backgroundColor: '#F0EAE0', padding: '80px 32px', width: '100%' },
  glosarioContenido: { maxWidth: '1100px', margin: '0 auto' },
  glosarioTitulo: { fontSize: '28px', fontWeight: '800', color: '#2C1810', textAlign: 'center', marginBottom: '40px', letterSpacing: '-0.5px' },
  glosarioGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' },
  glosarioItem: { display: 'flex', flexDirection: 'column', gap: '8px', backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '12px', border: '1px solid #E8E0D5' },
  glosarioTermino: { fontSize: '15px', fontWeight: '700', color: '#2C1810' },
  glosarioDesc: { fontSize: '14px', color: '#5C4033', lineHeight: '1.7' },
  ctaFinal: { backgroundColor: '#2C1810', padding: '80px 32px', textAlign: 'center' },
  ctaFinal_inner: { maxWidth: '500px', margin: '0 auto' },
  ctaFinal_titulo: { fontSize: '48px', fontWeight: '800', color: '#FAF8F5', marginBottom: '8px', letterSpacing: '-1px' },
  ctaFinal_sub: { fontSize: '20px', color: '#C4A882', marginBottom: '32px', fontStyle: 'italic' },
  ctaFinal_btn: { backgroundColor: '#C4A882', color: '#2C1810', border: 'none', padding: '16px 40px', borderRadius: '12px', fontSize: '16px', fontWeight: '700', cursor: 'pointer', marginBottom: '16px' },
  ctaFinal_nota: { fontSize: '13px', color: '#8B6F47' },
  contacto: { backgroundColor: '#dbd3c7', padding: '80px 32px', textAlign: 'center' },
  contactoContenido: { maxWidth: '600px', margin: '0 auto' },
  contactoTitulo: { fontSize: '32px', fontWeight: '700', color: '#2C1810', marginBottom: '16px', letterSpacing: '-0.5px' },
  contactoSubtitulo: { fontSize: '16px', color: '#2C1810', lineHeight: '1.7', marginBottom: '32px' },
  formularioContacto: { display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '480px', margin: '0 auto' },
  inputContacto: { padding: '12px 16px', borderRadius: '8px', border: '1px solid #E8E0D5', backgroundColor: '#fffefc', color: '#2C1810', fontSize: '14px', outline: 'none', width: '100%' },
  textareaContacto: { padding: '12px 16px', borderRadius: '8px', border: '1px solid #E8E0D5', backgroundColor: '#FAF8F5', color: '#2C1810', fontSize: '14px', outline: 'none', width: '100%', resize: 'vertical', fontFamily: 'inherit' },
  contactoBtn: { display: 'inline-block', backgroundColor: '#2C1810', color: '#FAF8F5', padding: '14px 32px', borderRadius: '10px', fontSize: '15px', fontWeight: '600', textDecoration: 'none', border: '2px solid #2C1810', cursor: 'pointer', width: '100%' },
  pwaBanner: { backgroundColor: '#F0F4E8', border: '1px solid #C8D5A0', borderRadius: '12px', padding: '14px 20px', display: 'flex', alignItems: 'flex-start', gap: '12px', maxWidth: '1100px', margin: '0 auto 32px' },
  pwaIcono: { fontSize: '22px', flexShrink: 0 },
  pwaTexto: { fontSize: '13px', color: '#3D4D1F', lineHeight: '1.6' },
  footer: { backgroundColor: '#2C1810', padding: '32px', borderTop: '1px solid #3D2418' },
  footerContenido: { maxWidth: '1100px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' },
  footerMarca: { display: 'flex', alignItems: 'center', gap: '8px' },
  logoFooter: { width: '48px', height: '48px', objectFit: 'cover', borderRadius: '50%' },
  footerCopy: { color: '#ac9370', fontSize: '15px' },
  footerLinks: { display: 'flex', gap: '16px', flexWrap: 'wrap' },
  footerLink: { color: '#C4A882', fontSize: '13px', textDecoration: 'none' },
  loginPagina: { minHeight: '100vh', backgroundColor: '#FAF8F5', display: 'flex', flexDirection: 'column' },
  loginContenido: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 16px' },
  loginCaja: { backgroundColor: '#FFFFFF', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '420px', border: '1px solid #E8E0D5', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  logoLoginGrande: { width: '100px', height: '100px', objectFit: 'contain', borderRadius: '50%', marginBottom: '16px' },
  loginSubtitulo: { fontSize: '14px', color: '#af9979', textAlign: 'center', marginBottom: '28px' },
  campo: { marginBottom: '16px', width: '100%' },
  label: { display: 'block', fontSize: '14px', fontWeight: '600', color: '#2C1810', marginBottom: '6px' },
  input: { width: '100%', padding: '12px 14px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '15px', outline: 'none', backgroundColor: '#FAF8F5', color: '#2C1810' },
  btnPrimarioFull: { width: '100%', padding: '13px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', marginTop: '4px', cursor: 'pointer' },
  errorDiv: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', border: '1px solid #F5C9B8', width: '100%' },
  enlace: { textAlign: 'center', fontSize: '14px', color: '#8B6F47', marginTop: '16px' },
  link: { color: '#2C1810', fontWeight: '600', cursor: 'pointer', textDecoration: 'underline' },
  btnArriba: { position: 'fixed', bottom: '80px', right: '24px', width: '44px', height: '44px', borderRadius: '50%', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', fontSize: '20px', cursor: 'pointer', boxShadow: '0 2px 12px rgba(44,24,16,0.25)', zIndex: 99 },
  landingNav: {}, landingNavContenido: {}, marca: {}, logoImg: {}, marcaNombre: {}, navBotones: {}, btnNavPrimario: {}, btnNavSecundario: {}, hamburguesa: {}, menuMovilLanding: {}, menuMovilBtn: {}, menuMovilBtnDestacado: {}, logoWrap: {}, loginMarca: {}, btnVolver: {}, logoLogin: {}, loginNav: {}, loginNavContenido: {}, btnVolverLogin: {},
}

export default Login